import { Text, IconButton, VStack, HStack } from '@genial/components';
import { Spacing, Color } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

import { BasketOfferFilesProps } from '../../../../utils/types';

type FilesContentProps = {
  basketOfferFile: BasketOfferFilesProps[] | undefined;
  handleOpenLink: (fileUrl: string) => void;
  handleClose: () => void;
};

export const FilesContent: React.FC<FilesContentProps> = ({
  basketOfferFile,
  handleOpenLink,
  handleClose,
}) => {
  return (
    <VStack
      py={Spacing['inline.xxs']}
      px={Spacing['inline.nano']}
      w={'full'}
      space={Spacing['inline.xxxs']}>
      <HStack justifyContent="space-between" flexDirection={'row'} w={'full'}>
        <Text fontSize="lg" color="brand.primary.darkest" fontWeight="semibold">
          Selecione o documento
        </Text>
        <IconButton
          onPress={handleClose}
          icon="Close"
          iconSize="xxxs"
          iconColor={Color['neutral.medium']}
          testId="icon-button-close-action-sheet"
          p={0}
        />
      </HStack>

      {basketOfferFile?.map((item, index) => (
        <Pressable
          onPress={() => handleOpenLink(item.fileUrl)}
          key={index}
          flexDirection={'row'}
          justifyContent="space-between"
          alignItems="center">
          <Text fontSize="md" color="brand.primary.darkest">
            {item.fileName}
          </Text>
          {item.fileName === 'Termo de aceite' ? (
            <IconButton
              icon={'Contracts'}
              iconSize="xs"
              iconColor={Color['brand.tertiary.principal']}
              testId="icon-button-close-action-sheet"
              p={0}
              onPress={() => handleOpenLink(item.fileUrl)}
            />
          ) : (
            <IconButton
              icon={'Declaration'}
              iconSize="xs"
              iconColor={Color['brand.tertiary.principal']}
              testId="icon-button-close-action-sheet"
              p={0}
              onPress={() => handleOpenLink(item.fileUrl)}
            />
          )}
        </Pressable>
      ))}
    </VStack>
  );
};
